import React, { useEffect, useState, useMemo } from 'react';
import axios from 'axios';
import { API_URL, ENDPOINTS } from '../constants/api';
import { decodeToken, getToken } from '../utils/TokenUtils';
import ModalForm from './ModalForm';
import Swal from 'sweetalert2';
import { updateColumn } from '../constants/functions';
import { replace } from 'react-router-dom';

function CustomerPortalDashbpard() {
  const token = getToken();
  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [sortColumn, setSortColumn] = useState(null);
  const [sortDirection, setSortDirection] = useState('asc');
  const [data, setData] = useState([]);
  const [activeTab, setActiveTab] = useState('All');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentRoute, setCurrentRoute] = useState('New-Problem-customer');
  const [selectedId, setSelectedId] = useState(null);
  const [StatusOptions, setStatusOptions] = useState([]);
  const userType = decodeToken(token, 'userLevel');
  const [selectedStatus, setSelectedStatus] = useState();

  
  const [IsOpenNewProblemprocessModel, setIsOpenNewProblemprocessModel] = useState(false);


  const openModal2 = (route) => {
    setCurrentRoute(route);
    setIsModalOpen(true);
    
    // console.log('allowed status for this problem is :', StatusOptions);
  };

  const closeModal = () => setIsModalOpen(false);

  const openModal3 = (route,status) => {
    setCurrentRoute(route);
    setSelectedStatus(status)
    setIsOpenNewProblemprocessModel(true);
  };
  const closeModal3 = () => setIsOpenNewProblemprocessModel(false);

  const user_id = decodeToken(token, 'id');

  const tabs = 
  [
    'All',
    'Pending',
    'Assigned',
    'Process',
     'Done',
    'Complete',
    'InComplete',
    'Cancel',
  ];

  const fetchProblems = async (status) => {
    setLoading(true);
    setError(null);
    const body = {user_id,status};
    try {
      const response = await axios.post(
        `${API_URL}/${ENDPOINTS.SYS}/reportCustom/get-problem-portal`,
        body,
        { headers: { Authorization: token ? `Bearer ${token}` : '' } }
      );
      setData(response.data?.data || []);
      // console.log('res from getproble', response.data);
    } catch (err) {
      setError('Failed to load data');
      setData([]);
    } finally {
      setLoading(false);
    }
    // console.log('data', data);
  };

  useEffect(() => {
    fetchProblems(activeTab);
  }, [activeTab]);

  const handleSort = (column) => {
    if (column === sortColumn) {
      setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
    } else {
      setSortColumn(column);
      setSortDirection('asc');
    }
    setCurrentPage(1);
  };

  const filteredData = useMemo(() => {
    let filtered = [...data];
    if (searchTerm) {
      filtered = filtered.filter((item) =>
        Object.values(item).some((value) =>
          value?.toString().toLowerCase().includes(searchTerm.toLowerCase())
        )
      );
    }
    if (sortColumn) {
      filtered.sort((a, b) => {
        const valA = a[sortColumn];
        const valB = b[sortColumn];
        if (typeof valA === 'string' && typeof valB === 'string') {
          return sortDirection === 'asc'
            ? valA.localeCompare(valB)
            : valB.localeCompare(valA);
        }
        return sortDirection === 'asc' ? valA - valB : valB - valA;
      });
    }
    return filtered;
  }, [data, searchTerm, sortColumn, sortDirection]);

  const totalItems = filteredData.length;
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);

  const renderSortArrow = (column) => {
    if (column !== sortColumn) return null;
    return sortDirection === 'asc' ? ' ▲' : ' ▼';
  };



  return (
    <div className="m-6 p-3 bg-gradient-to-br from-green-50 to-green-100 min-h-screen font-sans">
      <div className="bg-white rounded-3xl shadow-xl pl-5 mb-5">
        {/* Tabs */}
        <div className="flex flex-wrap justify-center mb-6 gap-4 mx-6 ">
          {tabs.map((tab) => (
            <button
              key={tab}
              onClick={() => setActiveTab(tab)}
              className={`mx-1 rounded-full px-9 py-3 text-base font-semibold min-w-[120px] transition-all duration-300 ease-in-out
                ${
                  activeTab === tab
                    ? 'bg-green-600 text-white shadow-md scale-105'
                    : 'bg-green-100 text-green-700 hover:bg-green-200'
                }`}
            >
              {tab}
            </button>
          ))}
        </div>

        {/* Search and Page Size */}
        <div className="flex flex-col md:flex-row gap-y-4 md:gap-x-6 mb-4 mt-4">
          <input
            type="text"
            placeholder="🔍 Search here..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="flex-1 p-3 border border-green-300 rounded-full focus:outline-none focus:ring-2 focus:ring-green-400 text-gray-700 placeholder-gray-400"
          />
          <select
            value={itemsPerPage}
            onChange={(e) => setItemsPerPage(Number(e.target.value))}
            className="p-3 border border-green-300 rounded-full focus:outline-none focus:ring-2 focus:ring-green-400 text-gray-700"
          >
            {[5, 10, 20, 50].map((size) => (
              <option key={size} value={size}>
                {size} / page
              </option>
            ))}
          </select>
          {(userType === 'developer' || userType === 'customer') && (
            <button
              onClick={() => openModal2('New-Problem-customer')}
              className="btn btn-primary p-3 m-5"
            >
              New Problem
            </button>
          )}
        </div>
      </div>

      {/* Table */}
      {loading ? (
        <div className="text-center py-10 text-green-600 text-2xl font-semibold">
          Loading... 🍃
        </div>
      ) : error ? (
        <div className="text-center py-10 text-red-500 text-xl font-semibold">
          Oops! Something went wrong: {error}
        </div>
      ) : (
        <div className="bg-white rounded-3xl shadow-xl p-4 overflow-auto mb-10">
          {currentItems.length > 0 ? (
            <div className="overflow-x-auto">
              <table className="min-w-full table-auto border border-green-300 text-sm">
                <thead className="bg-green-100">
                  <tr>
                   {activeTab=='Done' && (
                     <th className="px-3 py-2 text-green-800 font-bold border border-green-300">
                      Action
                    </th>


                   )}
                    {data[0] &&
                      Object.keys(data[0]).map((key) => (
                        <th
                          key={key}
                          className="px-3 py-2 text-left text-green-800 font-bold border border-green-300 cursor-pointer hover:bg-green-200"
                          onClick={() => handleSort(key)}
                        >
                          {key.replace(/([A-Z])/g, ' $1').trim()}
                          {renderSortArrow(key)}
                        </th>
                      ))}
                  </tr>
                </thead>
                <tbody>
                  {currentItems.map((item, index) => (
                    <tr key={index} className="hover:bg-green-50">
                      {
                        activeTab=='Done' && (
                          <td className="px-2 py-2 text-left border border-green-300">
                        {
                          ['Complete','InComplete'].map((status, index) => (
                            <button
                              style={{ margin: '10px' }}
                              key={index}
                              className="bg-blue-600 text-white px-3 py-1.5   rounded-full text-sm hover:bg-blue-700 transition-all inline-flex w-fit"
                              onClick={(e) => {
                                
                                  const idCell =
                                    e.currentTarget.closest('tr')?.children[1];
                                  if (idCell) {
                                    const id = idCell.textContent.trim();
                                    // console.log('problem id:', id);
                                    setSelectedId(id);
                                    // console.log('Selected ID:', id);
                                  }
                                   openModal3('new-problem-process-customer', status)
                                  
                                }
                              }
                            >
                              {status}
                            </button>
                          ))}</td>
                        )
                      }

                      {Object.entries(item).map(([key, val], i) => (
                        <td
                          key={i}
                          className={`
        px-3 py-3 border border-green-200 text-gray-800
        ${
          key.toLowerCase() === 'description'
            ? 'whitespace-pre-wrap break-words max-w-lg text-base font-medium text-gray-900'
            : key.toLowerCase() === 'id'
              ? 'font-bold text-sm text-green-800 text-center'
              : 'whitespace-nowrap max-w-[150px] overflow-hidden text-ellipsis text-sm'
        }
      `}
                        >
          {
  typeof val === "string" &&
  ['.png', '.jpg', '.jpeg'].some(ext =>
    val.toLowerCase().endsWith(ext)
  )
    ? (
        <img style={{width:'70px', height:'70px'}}
          src={`${API_URL}/${val.replace(/public\//g, '')}`}
          alt="preview"
          className="max-w-[80px] h-auto"
        />
      )
    : val
}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <div className="text-center py-8 text-gray-600 text-lg font-medium">
              No data found 🍃
            </div>
          )}

          {/* Pagination */}
          {totalItems > itemsPerPage && (
            <div className="flex justify-center mt-5 space-x-3">
              <button
                onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                disabled={currentPage === 1}
                className="px-4 py-2 bg-green-400 text-white rounded-full hover:bg-green-500 disabled:opacity-50"
              >
                Previous
              </button>
              <span className="px-4 py-2 text-green-800 font-semibold">
                Page {currentPage} of {Math.ceil(totalItems / itemsPerPage)}
              </span>
              <button
                onClick={() =>
                  setCurrentPage((prev) =>
                    Math.min(prev + 1, Math.ceil(totalItems / itemsPerPage))
                  )
                }
                disabled={currentPage === Math.ceil(totalItems / itemsPerPage)}
                className="px-4 py-2 bg-green-400 text-white rounded-full hover:bg-green-500 disabled:opacity-50"
              >
                Next
              </button>
            </div>
          )}
        </div>
      )}

      {/* Modal */}
      {isModalOpen && currentRoute && (
        <ModalForm
          userId={user_id}
          token={token}
          queryParams={'customer_contact_id=' + user_id + '&user_id=' + user_id}
          route={currentRoute}
          isOpen={isModalOpen}
          onRequestClose={closeModal}
        />
      )}

      {
      IsOpenNewProblemprocessModel && currentRoute && (
        <ModalForm
          userId={user_id}
          token={token}
          queryParams={'status='+selectedStatus+'&problem_id='+selectedId}
          route={currentRoute}
          isOpen={IsOpenNewProblemprocessModel}
          onRequestClose={closeModal3}
        />
      )}
    </div>
  );
}

export default CustomerPortalDashbpard;
